module.exports = __webpack_public_path__ + "img/arrow-90deg-left.b3ed0b42.svg";